import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {
    DialogActions,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Radio,
    RadioGroup,
    Switch,
    TextField
} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import SnackbarMessage from "../Custom/SnackbarMessage";
import {connect} from "react-redux";
import {clear_cluster_error} from "../../actions/clusters";
import {randomCode} from "../../utilities/random";
import {TextfieldDateTime} from "../../utilities/date";
import withStyles from "@mui/styles/withStyles";

const styles = {
    input: {
        marginTop: 15
    },
};

class CouponDialog extends Component {

    constructor(props) {
        super(props);
        this.state = props.coupon ?
            {
                type: props.coupon.type,
                value: parseFloat(props.coupon.value),
                code: props.coupon.code,
                allowed: props.coupon.allowed,
                usages: props.coupon.usages ? props.coupon.usages : "",
                begin_at: props.coupon.begin_at ? TextfieldDateTime(new Date(props.coupon.begin_at)) : "",
                expiration_at: props.coupon.expiration_at ? TextfieldDateTime(new Date(props.coupon.expiration_at)) : "",
                active: Boolean(props.coupon.active),
                typeTouched: false,
                valueTouched: false,
                codeTouched: false,
                allowedTouched: false,
                usagesTouched: false,
                activeTouched: false,
                begin_atTouched: false,
                expiration_atTouched: false,
            } : {
                type: "fixed",
                value: "",
                code: randomCode(5),
                allowed: "any",
                usages: "",
                begin_at: "",
                expiration_at: "",
                active: true,
                typeTouched: false,
                valueTouched: false,
                codeTouched: false,
                allowedTouched: false,
                usagesTouched: false,
                begin_atTouched: false,
                expiration_atTouched: false,
                activeTouched: false,
            };
    }

    onChange = e => {
        if (e.target.name === "code") {
            e.target.value = e.target.value.trim().slice(0, 35).toUpperCase();
        }
        this.setState({
            [e.target.name]: e.target.name === "active" ? e.target.checked : e.target.value,
            [e.target.name + 'Touched']: true
        })
    };

    isCodeInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.codeTouched) return false;
        if (this.state.code.length < 5) return "Code must be at least 5 characters long.";
        if (this.state.code.length > 35) return "Code must be maximum 35 characters long.";
        return false;
    }

    isValueInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.valueTouched) return false;
        if (this.state.value === "") return "Value must not be empty";
        if (isNaN(this.state.value)) return "Value must be number";
        if (this.state.value <= 0) return "Value must be greater than 0";
        return false;
    }

    isUsagesInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.usagesTouched) return false;
        if (this.state.usages !== "" && isNaN(this.state.usages)) return "Usages must be number";
        return false;
    }

    isValid() {
        return !this.isCodeInvalid(true) && !this.isValueInvalid(true) && !this.isUsagesInvalid(true);
    }

    render() {
        const {classes} = this.props;
        return (<Dialog open={true} onClose={() => this.props.handleClose()}>
                <DialogTitle>{this.props.coupon ? "Modify coupon" : "Create coupon"}</DialogTitle>
                <DialogContent>
                    {this.props.errors && <SnackbarMessage onClose={() => this.props.clearErrors()} type="error"
                                                           message={this.props.errors} autoHideDuration={null}
                                                           anchorOrigin={false}
                                                           style={{marginBottom: 30}}/>}

                    <FormControl component="fieldset">
                        <FormLabel component="legend">Type</FormLabel>
                        <RadioGroup row name="type" value={this.state.type} onChange={this.onChange}>
                            <FormControlLabel value="fixed" control={<Radio/>} label="Fixed"/>
                            <FormControlLabel value="percentage" control={<Radio/>} label="Percentage"/>
                        </RadioGroup>
                    </FormControl>

                    <TextField
                        variant="standard"
                        margin="dense"
                        name="code"
                        label="Code"
                        type="text"
                        value={this.state.code}
                        className={classes.input}
                        fullWidth
                        onChange={this.onChange}
                        helperText={this.isCodeInvalid()}
                        error={Boolean(this.isCodeInvalid())}
                        required
                    />

                    <TextField
                        variant="standard"
                        margin="dense"
                        name="value"
                        label="Value"
                        type="number"
                        value={this.state.value}
                        className={classes.input}
                        fullWidth
                        onChange={this.onChange}
                        helperText={this.isValueInvalid()}
                        error={Boolean(this.isValueInvalid())}
                        required
                    />
                    <TextField
                        variant="standard"
                        margin="dense"
                        name="usages"
                        label="Usages"
                        placeholder="Leave blank if infinite"
                        type="number"
                        value={this.state.usages}
                        className={classes.input}
                        fullWidth
                        onChange={this.onChange}
                        helperText={this.isUsagesInvalid()}
                        error={Boolean(this.isUsagesInvalid())}
                    />

                    <FormGroup
                        className={classes.input}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Allowed</FormLabel>
                            <RadioGroup row name="allowed" value={this.state.allowed} onChange={this.onChange}>
                                <FormControlLabel value="any" control={<Radio/>} label="Any"/>
                                <FormControlLabel value="lite" control={<Radio/>} label="Lite"/>
                                <FormControlLabel value="great" control={<Radio/>} label="Great"/>
                            </RadioGroup>
                        </FormControl>
                    </FormGroup>

                    <FormGroup
                        className={classes.input}>
                        <TextField
                            variant="standard"
                            name="begin_at"
                            label="Begin at"
                            type="datetime-local"
                            value={this.state.begin_at}
                            onChange={this.onChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormGroup>

                    <FormGroup
                        className={classes.input}>

                        <TextField
                            variant="standard"
                            name="expiration_at"
                            label="Expiration at"
                            type="datetime-local"
                            value={this.state.expiration_at}
                            onChange={this.onChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormGroup>

                    <FormGroup
                        className={classes.input}>
                        <FormControl component="fieldset">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.active}
                                        onChange={this.onChange}
                                        name="active"
                                        color="primary"
                                    />
                                }
                                label="Active"
                            />
                        </FormControl>
                    </FormGroup>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.props.handleClose()} color="primary">
                        Cancel
                    </Button>
                    <Button disabled={!this.isValid()} onClick={() => this.props.handleSave(this.state)}
                            color="primary">
                        {this.props.coupon ? "Save" : "Create"}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => ({
    error: state.clusters.error,
});
export default withStyles(styles)(connect(
    mapStateToProps,
    {clear_cluster_error}
)(CouponDialog));
